<agpr-prime-autocomplete-override-overlay-panel
    #autocomplete
    [inputId]="id"
    [(ngModel)]="selectedItem"
    [suggestions]="filteredItems"
    [field]="labelField"
    [dropdown]="dropdown"
    appendTo="body"
    (completeMethod)="performAutocomplete($event.query)"
    (select)="onItemSelect($event)"
    (clear)="clearInput()"
    [placeholder]="placeholder | localize"
    [maxlength]="64"
    [minLength]="minLength"
    [disabled]="disabled"
    dropdownIcon="fa-solid fa-angle-down"
    class="agpr-autocomplete"
    [group]="true"
    [optionGroupChildren]="optionGroupChildren"
    [autoHighlight]="autoHighlight"
    [forceSelection]="forceSelection"
    (keyUp)="keyup.emit($event)"
    (blur)="onInputBlur($event)"
    [panelStyleClass]="'agpr-clickOutsideExcluded agpr-autocomplete-panel'"
    [ngClass]="{
        'agpr-autocomplete-dropdown' : dropdown,
        'agpr-autocomplete-placeholder' : !selectedItem
    }"
    [groupTemplate]="groupTemplate"
    [itemsListTemplate]="itemsListTemplate"
    [overlayTemplate]="overlayTemplate"
    [showEmptyMessage]="showEmptyMessage"
    [footerTemplate]="footerTemplate"
    (viewAllInGroup)="triggerViewAllInGroup($event)"
    (researchRequest)="triggerResearchRequest($event)"
    [ariaLabelledBy]="ariaLabelledBy"
    [type]="inputType"
    [ariaDescribedBy]="ariaDescribedBy"
    [resultListAriaLabel]="resultListAriaLabel"
    [autocomplete]="autocomplete"
>
</agpr-prime-autocomplete-override-overlay-panel>
